import React from "react";

export default function Bottom() {
  return (
    <div className="footer">
      <div>Copyright © 2022, e-commerce - $STORE
      </div>
      <div>
        Elaborado por: &nbsp; 
           Jose Fuentes | WhatsApp: <a rel="noreferrer" title="Me interesa conversar contigo acerca de una dApp" href="https://api.whatsapp.com/send?phone=+584128256644&amp;text=Hola%2C%20deseo%20realizar%20una%20consulta%20de%20una%20dApp" target="_blank" >+58 (412) 825.66.44</a>
      </div>
    </div>
  );
}
